import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    let storedUser = null;
    try {
        storedUser = JSON.parse(localStorage.getItem('user') || 'null');
    } catch (error) {
        console.warn('ProtectedRoute: invalid stored user session', error);
    }

    const hasUser = Boolean(storedUser && typeof storedUser === 'object' && Object.keys(storedUser).length > 0);

    if (!hasUser) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
